export enum BANK_ACCOUNT_STATE {
	FORM = 'FORM',
	CODE = 'CODE',
}
